(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('PromoCodeDeleteController',PromoCodeDeleteController);

    PromoCodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PromoCode'];

    function PromoCodeDeleteController($uibModalInstance, entity, PromoCode) {
        var vm = this;

        vm.promoCode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PromoCode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
